/** Marketing and Surveys mount the same pages, so links stay in the current module. */
export const automationsBasePath = (pathname: string): string => (
    pathname.startsWith('/surveys') ? '/surveys/automations' : '/marketing/automations'
);
